import { applyThemeGridSxOverrides } from '@/Infrastructure/Theme/AppThemeOverrides';

/**
 * Base row height for every Agent Settlements grid. The active density scales this
 * (compact = 0.7), so 44 yields a 30px compact row — tighter than the 36px default.
 */
export const settlementsRowHeight = 44;

/**
 * Applied by money columns to cells holding a negative value, matching the red the Summary tab
 * uses for the same amounts. Styled by settlementsGridSx, so every tab picks it up for free.
 */
export const negativeAmountClass = 'settlements-negative-amount';

/** Shared DataGrid sx for every Agent Settlements tab: theme overrides plus bold column headers. */
export const settlementsGridSx = {
  ...applyThemeGridSxOverrides(),
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700
  },
  [`& .${negativeAmountClass}`]: {
    color: 'var(--mui-palette-error-main)'
  }
};
